import React from 'react';
import { FaArrowRight } from '@react-icons/all-files/fa/FaArrowRight';
import OperatorCta from 'gatsby-core-theme/src/components/atoms/button/button';
import { getExtraField, imagePrettyUrl, getAltText } from 'gatsby-core-theme/src/helpers/getters';
import styles from './template-one.module.scss';
import ReviewCredits from 'gatsby-matrix-theme/src/components/atoms/review-credits';
import StatisticsCounter from 'gatsby-matrix-theme/src/components/atoms/statistics-counter';
import LazyImage from 'gatsby-core-theme/src/hooks/lazy-image';

export default ({ page }) => {
  const { title, description, extraFields, date, featured_image_object, categories } = page;

  const lottoUk49 = categories?.some((res) => res.short_name === 'lotto_uk_49');

  const showReviewCredits =
    page.path !== '/' &&
    page.path !== 'contact-us' &&
    page.path !== 'news' &&
    page.path !== 'sitemap' &&
    page.template !== 'ppc' &&
    page.author_id;

  const link = getExtraField(extraFields, 'link');

  const statsCounter = page?.sections?.header?.modules?.find(
    (modules) => modules?.name === 'statistics_counter'
  );

  return (
    <div className={styles.templateOneContainer}>
      <div className={`${styles.templateOne} ${lottoUk49 ? styles.lottoUk49 : ''}`}>
        <div className={`${styles.headerContainer} ${lottoUk49 ? styles.info : ''}`}>
          {page.path !== 'contact-us' && <h1 className={lottoUk49 ? styles.lottoTitle : ""}>{title}</h1>}

          {description && (
            <div
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{ __html: description }}
              className={`${styles.description} ${lottoUk49 ? styles.lottoDesc : ''}`}
            />
          )}

          {showReviewCredits && !lottoUk49 && (
            <ReviewCredits
              authors={page?.allAuthors ? page?.allAuthors : page?.author_id && [page?.author]}
              reviewer={page.reviewer_id && page?.reviewer}
              date={date}
              readingTime={page.reading_time}
              hasAuthorBox={page.author_id}
            />
          )}
          {link && (
            <OperatorCta
              to={link}
              btnText={link}
              type="invertColors"
              gtmClass="default-header-template-one-gtm btn-cta"
              icon={<FaArrowRight title="Right-pointing Arrow Icon" />}
            />
          )}
        </div>
        {featured_image_object?.filename && lottoUk49 && (
          <LazyImage
            loading="eager"
            src={imagePrettyUrl(featured_image_object?.filename, 343, 343)}
            width={343}
            height={343}
            alt={getAltText(featured_image_object, featured_image_object?.title)}
          />
        )}
      </div>
      {lottoUk49 && (
            <ReviewCredits
              authors={page?.allAuthors ? page?.allAuthors : page?.author_id && [page?.author]}
              reviewer={page.reviewer_id && page?.reviewer}
              date={date}
              readingTime={page.reading_time}
              hasAuthorBox={page.author_id}
            />
          )}
      {statsCounter && <StatisticsCounter page={page} module={statsCounter} />}
    </div>
  );
};
